import { render, staticRenderFns } from "./EmptySpoumArea.vue?vue&type=template&id=408fb782&scoped=true&"
import script from "./EmptySpoumArea.vue?vue&type=script&lang=js&"
export * from "./EmptySpoumArea.vue?vue&type=script&lang=js&"
import style0 from "./EmptySpoumArea.vue?vue&type=style&index=0&id=408fb782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408fb782",
  null
  
)

export default component.exports